@if (payload(); as p) {
  @if (isExcelDownload(p)) {
    <div class="action-card action-card--excel">
      <div class="action-card__header">
        <span class="action-card__icon">📊</span>
        <span class="action-card__title">{{
          p.card.title || p.card.filename
        }}</span>
      </div>
      <div class="action-card__body">
        <div class="action-card__file-meta">
          <span class="action-card__file-chip">{{ p.card.filename }}</span>
          <span class="action-card__file-chip">
            {{ p.card.sizeBytes | filesize }}
          </span>
          <span class="action-card__file-chip"
            >{{ p.card.sheetCount }} sheet{{
              p.card.sheetCount !== 1 ? 's' : ''
            }}</span
          >
        </div>
        @if (excelError()) {
          <div class="action-card__status action-card__status--error">
            {{ excelError() }}
          </div>
        }
        <button
          class="action-card__button action-card__button--download"
          type="button"
          [disabled]="excelDownloading()"
          (click)="downloadExcel(p)">
          @if (excelDownloading()) {
            <mat-spinner diameter="16" />
          }
          {{
            excelDownloading() ? 'Downloading...' : p.card.button || 'Download'
          }}
        </button>
      </div>
    </div>
  }
  @if (isWordDownload(p)) {
    <div class="action-card action-card--word">
      <div class="action-card__header">
        <span class="action-card__icon">📄</span>
        <span class="action-card__title">{{
          p.card.title || p.card.filename
        }}</span>
      </div>
      <div class="action-card__body">
        <div class="action-card__file-meta">
          <span class="action-card__file-chip">{{ p.card.filename }}</span>
          <span class="action-card__file-chip">
            {{ p.card.sizeBytes | filesize }}
          </span>
          @if (p.card.sectionCount) {
            <span class="action-card__file-chip"
              >{{ p.card.sectionCount }} section{{
                p.card.sectionCount !== 1 ? 's' : ''
              }}</span
            >
          }
        </div>
        @if (wordError()) {
          <div class="action-card__status action-card__status--error">
            {{ wordError() }}
          </div>
        }
        <button
          class="action-card__button action-card__button--download"
          type="button"
          [disabled]="wordDownloading()"
          (click)="downloadWord(p)">
          @if (wordDownloading()) {
            <mat-spinner diameter="16" />
          }
          {{
            wordDownloading() ? 'Downloading...' : p.card.button || 'Download'
          }}
        </button>
      </div>
    </div>
  }
  @if (isSendEmail(p)) {
    <div class="action-card action-card--email">
      <div class="action-card__header">
        <span
          class="action-card__title"
          [title]="p.card.title || 'Send email'"
          >{{ p.card.title || 'Send email' }}</span
        >
      </div>
      <div class="action-card__body">
        <div class="action-card__field">
          <div class="action-card__label-row">
            <label class="action-card__label">To</label>
            <button
              type="button"
              class="action-card__copy-icon"
              (click)="copyTo()"
              [attr.aria-label]="'GNR_ALLO_EMAIL_COPY_TO' | translate">
              <mat-icon>{{
                copiedField() === 'to' ? 'check' : 'content_copy'
              }}</mat-icon>
            </button>
          </div>
          <div class="action-card__to-row">
            @for (r of recipientsList(); track $index) {
              <span class="action-card__chip">
                {{ r.name || r.email }}
                <button
                  type="button"
                  class="action-card__chip-remove"
                  (click)="removeRecipient($index)"
                  aria-label="Remove recipient">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            }
            @if (hasRecipientsList()) {
              <input
                class="action-card__input action-card__input--add"
                type="text"
                [ngModel]="newRecipient()"
                (ngModelChange)="onAddRecipientInput($event, true)"
                (keydown.enter)="addRecipientFromInput($event)"
                (keydown.tab)="onRecipientInputTab($event)"
                (blur)="tryAddRecipientOnBlur()"
                placeholder="Add recipient..." />
            } @else {
              <input
                class="action-card__input action-card__input--add"
                type="text"
                [ngModel]="toSingle()"
                (ngModelChange)="onAddRecipientInput($event, false)"
                (keydown.enter)="addRecipientFromInput($event)"
                (keydown.tab)="onRecipientInputTab($event)"
                (blur)="tryAddRecipientOnBlur()"
                placeholder="Add recipient..." />
            }
          </div>
        </div>

        <div class="action-card__field">
          <div class="action-card__label-row">
            <label class="action-card__label">Subject</label>
            <button
              type="button"
              class="action-card__copy-icon"
              (click)="copySubject()"
              [attr.aria-label]="'GNR_ALLO_EMAIL_COPY_SUBJECT' | translate">
              <mat-icon>{{
                copiedField() === 'subject' ? 'check' : 'content_copy'
              }}</mat-icon>
            </button>
          </div>
          <input
            #subjectInput
            class="action-card__input"
            type="text"
            [ngModel]="subject()"
            (ngModelChange)="subject.set($event)"
            placeholder="Subject" />
        </div>

        <div class="action-card__field">
          <div class="action-card__label-row">
            <label class="action-card__label">Message</label>
            <button
              type="button"
              class="action-card__copy-icon"
              (click)="copyMessage()"
              [attr.aria-label]="'GNR_ALLO_EMAIL_COPY_MESSAGE' | translate">
              <mat-icon>{{
                copiedField() === 'message' ? 'check' : 'content_copy'
              }}</mat-icon>
            </button>
          </div>
          <!--
            SD-2708: a read-only rendered preview rather than a textarea. The body is copied to
            the clipboard now, not put in a mailto URL, so it can carry real formatting — and it
            is rendered through the same service the chat uses so the two match.
          -->
          <div
            class="action-card__message"
            [innerHTML]="renderedContent()"></div>
        </div>

        @if (handledByServer()) {
          <div class="action-card__status action-card__status--ok">
            Email sent by the assistant.
          </div>
        } @else {
          <div class="action-card__copy-row">
            <button
              class="action-card__button action-card__button--copy"
              type="button"
              (click)="copyMessage()">
              <mat-icon class="action-card__button-icon">{{
                copiedField() === 'message' ? 'check' : 'content_copy'
              }}</mat-icon>
              {{
                (copiedField() === 'message'
                  ? 'GNR_ALLO_EMAIL_COPIED'
                  : 'GNR_ALLO_EMAIL_COPY_MESSAGE'
                ) | translate
              }}
            </button>
            <span class="action-card__hint">
              {{ 'GNR_ALLO_EMAIL_PASTE_HINT' | translate }}
            </span>
          </div>
        }
      </div>
    </div>
  }
  <!--
    SD-2771: one contained card — the question on top, then the action zone. Both actions are
    full-width and stacked in every state, including after a click, so taking one never moves the
    other out from under the cursor.
  -->
  @if (isSupportHandoff(p)) {
    <div class="action-card action-card--handoff">
      <div class="action-card__handoff-question">
        <span class="action-card__handoff-label">{{
          'GNR_ALLO_YOUR_QUESTION' | translate
        }}</span>
        <p class="action-card__handoff-text">{{ p.card.question }}</p>
      </div>
      <div class="action-card__handoff-actions">
        @if (chatAvailable()) {
          <button
            class="action-card__handoff-btn action-card__handoff-btn--primary"
            [class.action-card__handoff-btn--taken]="handoffOpened()"
            type="button"
            (click)="messageSupport(p)">
            {{ 'GNR_ALLO_MESSAGE_SUPPORT' | translate }}
          </button>
          @if (handoffOpened()) {
            <span class="action-card__handoff-taken-note">{{
              'GNR_ALLO_OPENED_IN_SUPPORT_CHAT' | translate
            }}</span>
          }
        } @else if (chatAvailable() === false) {
          <!-- No chat control at all when it cannot be used, and email becomes the primary route. -->
          <span class="action-card__handoff-notice">{{
            (outsideWorkingHours()
              ? 'GNR_ALLO_CHAT_OUTSIDE_HOURS'
              : 'GNR_ALLO_CHAT_UNAVAILABLE'
            ) | translate
          }}</span>
        }
        <button
          class="action-card__handoff-btn"
          [class.action-card__handoff-btn--primary]="chatAvailable() === false"
          [class.action-card__handoff-btn--secondary]="
            chatAvailable() !== false
          "
          type="button"
          (click)="emailSupport(p)">
          {{ supportEmail }}
        </button>
      </div>
    </div>
  }
  @if (isCreateNote(p)) {
    <div class="action-card action-card--note">
      <div class="action-card__header">
        <span class="action-card__icon">📝</span>
        <span class="action-card__title">{{
          p.card.title || ('GNR_NEW_NOTE' | translate)
        }}</span>
      </div>
      <div class="action-card__body">
        <div class="action-card__field">
          <label class="action-card__label">{{
            'GNR_TITLE' | translate
          }}</label>
          <input
            class="action-card__input"
            type="text"
            [(ngModel)]="noteTitle"
            [placeholder]="'GNR_ENTER_NOTE_TITLE' | translate"
            [disabled]="noteCreated()" />
        </div>

        <div class="action-card__field">
          <label class="action-card__label">{{
            'GNR_CONTENT' | translate
          }}</label>
          <textarea
            class="action-card__textarea"
            [(ngModel)]="noteContent"
            rows="6"
            [placeholder]="'GNR_ENTER_NOTE_CONTENT' | translate"
            [disabled]="noteCreated()"></textarea>
        </div>

        @if (noteError()) {
          <div class="action-card__status action-card__status--error">
            {{ noteError() | translate }}
          </div>
        }

        @if (noteCreated()) {
          <div class="action-card__status action-card__status--ok">
            <mat-icon>check_circle</mat-icon>
            {{ 'GNR_NOTE_CREATED' | translate }}
          </div>
        } @else {
          <button
            class="action-card__button action-card__button--note"
            type="button"
            (click)="createNote()">
            {{ p.card.button || ('GNR_SAVE_NOTE' | translate) }}
          </button>
        }
      </div>
    </div>
  }
  @if (isCreateTask(p)) {
    <div class="action-card action-card--task">
      <div class="action-card__header">
        <span class="action-card__icon">✅</span>
        <span class="action-card__title">{{
          p.card.title || ('GNR_NEW_TASK' | translate)
        }}</span>
      </div>
      <div class="action-card__body">
        <div class="action-card__field">
          <label class="action-card__label">{{
            'GNR_TITLE' | translate
          }}</label>
          <input
            class="action-card__input"
            type="text"
            [(ngModel)]="taskTitle"
            [placeholder]="'GNR_ENTER_TASK_TITLE' | translate"
            [disabled]="taskSubmitting() || taskCreated()" />
        </div>

        <div class="action-card__field">
          <label class="action-card__label">{{ 'GNR_DESC' | translate }}</label>
          <textarea
            class="action-card__textarea"
            [(ngModel)]="taskDescription"
            rows="4"
            [placeholder]="'GNR_DESCRIBE_TASK' | translate"
            [disabled]="taskSubmitting() || taskCreated()"></textarea>
        </div>

        <div class="action-card__field-row">
          <div class="action-card__field action-card__field--half">
            <label class="action-card__label">{{
              'GNR_EXECUTE_DATE' | translate
            }}</label>
            <input
              class="action-card__input"
              type="date"
              [(ngModel)]="taskDueDate"
              [disabled]="taskSubmitting() || taskCreated()" />
          </div>

          <div class="action-card__field action-card__field--half">
            <label class="action-card__label">{{
              'GNR_ASSIGNEE' | translate
            }}</label>
            <input
              class="action-card__input"
              type="text"
              [ngModel]="taskAssignee()"
              (ngModelChange)="onAssigneeInput($event)"
              [matAutocomplete]="assigneeAuto"
              [placeholder]="'GNR_ASSIGNEE' | translate"
              [disabled]="taskSubmitting() || taskCreated()" />
            <mat-autocomplete
              #assigneeAuto="matAutocomplete"
              (optionSelected)="onAssigneeOptionSelected($event.option.value)">
              @for (contact of assigneeSuggestions(); track contact.id) {
                <mat-option [value]="contact.name">{{
                  contact.name
                }}</mat-option>
              }
            </mat-autocomplete>
          </div>
        </div>

        @if (taskError()) {
          <div class="action-card__status action-card__status--error">
            {{ taskError() | translate }}
          </div>
        }

        @if (taskCreated()) {
          <div class="action-card__status action-card__status--ok">
            <mat-icon>check_circle</mat-icon>
            {{ 'GNR_TASK_CREATED' | translate }}
          </div>
        } @else {
          <button
            class="action-card__button action-card__button--task"
            type="button"
            [disabled]="!canCreateTask()"
            (click)="createTask()">
            @if (taskSubmitting()) {
              <mat-spinner diameter="16" />
            }
            {{
              taskSubmitting()
                ? ('GNR_CREATING' | translate)
                : p.card.button || ('GNR_CREATE_TASK' | translate)
            }}
          </button>
        }
      </div>
    </div>
  }
}
